var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.361,
    height: 88.361,
    viewBox: "0 0 88.361 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(22.908 38.811) rotate(-75.75)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(52.953 38.906) rotate(-76.72)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    "data-name": "Path 4139",
    d: "M3182.771,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,3182.771,533.19ZM3222,577.37a39.226,39.226,0,1,1-39.225-39.225A39.27,39.27,0,0,1,3222,577.37Z",
    transform: "translate(-3138.59 -533.19)",
    fill: "#f69138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    d: "M3325.142,869.906a57.923,57.923,0,0,0-43.839,0,2.477,2.477,0,0,0,.937,4.77,2.414,2.414,0,0,0,.935-.185,53.679,53.679,0,0,1,21.459-3.922,52.855,52.855,0,0,1,18.635,3.922,2.45,2.45,0,0,0,.936.186,2.494,2.494,0,0,0,.96-.2,2.477,2.477,0,0,0-.022-4.576Z",
    transform: "translate(-3259.042 -816.809)",
    fill: "#f69138"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/Okay.622552ab5841e42532bbbd70fa9c27c7.svg";
export { ForwardRef as ReactComponent };